import { render, staticRenderFns } from "./PasswordExpiration.vue?vue&type=template&id=1131b9e6&scoped=true&"
import script from "./PasswordExpiration.vue?vue&type=script&lang=js&"
export * from "./PasswordExpiration.vue?vue&type=script&lang=js&"
import style0 from "./PasswordExpiration.vue?vue&type=style&index=0&id=1131b9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131b9e6",
  null
  
)

export default component.exports